<template>
    <b-form @submit.prevent="onSubmit">
      <b-form-group id="input-group-1" :label="$_.capitalize($t('request-subject'))" label-for="input-1">
        <b-form-input
          id="input-1"
          v-model="form.subject"
          required
          :placeholder="$_.capitalize($t('type subject of issue'))"
        ></b-form-input>
      </b-form-group>
      <b-form-group id="input-group-2" :label="$_.capitalize($t('issue-type'))" label-for="input-2">
        <b-form-select
          id="input-group-2"
          v-model="form.type"
          :options="typeOptions"
        ></b-form-select>
      </b-form-group>
      <b-form-group
        id="input-group-3"
        :label="$_.capitalize($t('issue-description'))"
        label-for="input-3"
      >
        <b-form-textarea
          id="input-group-3"
          v-model="form.description"
          :placeholder="$t('write what happened')"
          rows="3"
          max-rows="8"
        ></b-form-textarea>
      </b-form-group>
      <b-button type="submit" variant="primary" class="float-right" :disabled="isWaiting">
        <template v-if="isWaiting">
          <b-spinner small type="grow"></b-spinner>
        </template>
        {{ $t('send') | capitalize }}
      </b-button>
    </b-form>
</template>

<script>
import axios from 'axios';
import config from '@/config';
import ToasterMixin from '@/mixins/Toaster';
import { mapState } from 'vuex';

export default {
  name: 'TicketForm',
  mixins: [
    ToasterMixin,
  ],
  data() {
    return {
      isWaiting: false,
      typeOptions: [
        {
          value: 'Dotaz',
          text: this.$t('question'),
        },
        {
          value: 'Problém',
          text: this.$t('problem'),
        },
        {
          value: 'Chyba',
          text: this.$t('bug'),
        },
        {
          value: 'Požadavek na úpravu',
          text: this.$t('change-request'),
        },
      ],
      form: {
        subject: '',
        type: 'Dotaz',
        description: '',
      },
    };
  },
  computed: {
    ...mapState('snapshot', [
      'currentSnapshot',
    ]),
    currentSnapshotInfoStr() {
      return `project id: ${this.currentSnapshot.project}, snapshot: ${this.currentSnapshot.name}, id ${this.currentSnapshot.id}`;
    },
  },
  methods: {
    onSubmit() {
      this.isWaiting = true;
      const url = new URL(
        config.ICOOL.API.HELPDESK_TICKET,
        config.ICOOL.BACKEND_HOST,
      ).href;
      const data = { ...this.form, tags: ['frontend'] };
      data.description = `${data.description}\n\n${this.currentSnapshotInfoStr}`;
      axios
        .post(url, data)
        .then(
          (response) => {
            this.isWaiting = false;
            this.showSuccessToast();
            this.form.subject = '';
            this.form.description = '';
          },
          (error) => {
            this.isWaiting = false;
            this.showErrorToast();
          },
        );
    },
    showSuccessToast() {
      this.showToast(this.$t('helpdesk-message'), this.$t('sended'), 'success');
    },
    showErrorToast() {
      this.showToast(this.$t('helpdesk-message'), this.$t('sending-error'), 'danger');
    },
  },
};
</script>

<style scoped>

</style>
